import { render, staticRenderFns } from "./specific-ai.vue?vue&type=template&id=80392bc4&scoped=true"
import script from "./specific-ai.vue?vue&type=script&lang=js"
export * from "./specific-ai.vue?vue&type=script&lang=js"
import style0 from "./specific-ai.vue?vue&type=style&index=0&id=80392bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80392bc4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default,PageBottom: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-bottom/index.vue').default})
